<template>
    <div class="slide-content"
    :style="{
        height: windowResize
    }"
    >
        <Loader v-if="loader.isWaiting" :message="loader.message"></Loader>
        <div class="slider" v-else>
            <slide-header 
                :title="currentParameter.title"
                :index="index"
                :maxIndex="routesParams.length"
                :rightOption="true"
                :rightTitle='$t("components.PageSlider.SlideContent.rightTitle")'></slide-header>
            <div class="slide-body">
                <slot></slot>
            </div>
            <slide-arrow
                :index="index"
                :maxIndex="routesParams.length"
                side="left" @newIndex="newIndex($event)"></slide-arrow>
            <slide-arrow
                :index="index"
                :maxIndex="routesParams.length"
                side="right" @newIndex="newIndex($event)"></slide-arrow>
            <div class="color-label"
                v-if="currentParameter.path == '/report/graphic'"
                :style="{
                    background: colors.theme == 'dark' ? '#000' : '#f0f0f0'  
                }">
                <div class="piece" :style="{background: colors.secondary}"></div>
                <span class="label-you" :style="{color: colors.secondary}">Você</span>
            </div>   
        </div>
    </div>
</template>
<script>
import SlideHeader from './SlideHeader.vue'
import SlideArrow from './SlideArrow'
import Loader from "../Loaders/LoaderFullMessage"
import Bus from '../../main'
export default {
    components : {
        SlideHeader,
        SlideArrow,
        Loader
    },
    data(){
        return{
            colors:JSON.parse(localStorage.getItem("colors")),
            index : 0,
            routeName: '',
            loader:{
                isWaiting: false,
                message:  this.$t("components.PageSlider.SlideContent.loader.message")
            }
        }
    },
    created(){
        Bus.$on('updateCurrent', this.updateCurrent)
    },
    destroyed(){
        Bus.$off('updateCurrent')
    },
    props: {
        routesParams : {
            type : Array,
            required : true
        }
    },
    methods: {
        newIndex(index){
            this.index = index
            if(this.currentParameter.title == "Gupy Redirect"){
                this.loader.isWaiting = true
                Bus.$off('openAlertGlobal')    
                setTimeout(() => { window.location.replace(this.currentParameter.path)}, 5000);
                return
            }
            this.$router.push(this.currentParameter.path)
        },
        updateCurrent(path){
            let current = ''
            this.routesParams.forEach((route, index) => {
                if(route.path == path){
                    current = index
                    return
                }
                return
            })

          this.index = current
        }
    },
    computed: {
        currentParameter(){
            // console.log("this.routesParams[this.index]: ", this.routesParams[this.index])
            return this.routesParams[this.index]
        },
        windowResize(){
            const windowWidth = window.innerWidth
            // if()
            // currentParameter.path == '/report/graphic' ? 'calc(100vh - 115px)'
            return windowWidth > 750 ? 'calc(650px - 75px)' : 'calc(100vh - 105px)'
        }
    }
}
</script>
<style lang="scss" scoped>
    .slide-content, .slider{
        height: 92%;
        position: relative;

        .slide-body{
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;    
            justify-content: center;            
        }
    }
  .color-label{
    display: flex;
    background: #000;
    height: 5vh;
    justify-content: center;
    align-items: center;   
    
    .piece{
      width: 50px;
      height: 10px;
      border-radius: 20px;
      margin-right: 5px; 
    }
    span{
      text-transform: capitalize;
    }
    .label-you{
        margin-right:  25px;
    }
  }    
  @media only screen and (min-width : 750px) {
      .slide-content, .slider{
          height: 100%;
      }
  }
</style>
